import React from "react";
import { NoSoundSVG, SoundSVG } from "../../assets/svgs";

const SoundButton = ({ soundFlag, onClick }) => {
  return (
    <button
      className="green-buttonQuiz"
      style={{ border: "none" }}
      onClick={onClick}
    >
      {soundFlag === "no" ? (
        <span>
          <NoSoundSVG />
        </span>
      ) : (
        <span className="">
          <SoundSVG />
        </span>
      )}
    </button>
  );
};

export default SoundButton;
